import React from 'react';
import ReactDOM from 'react-dom/client';
// #105 (plan D1): CSS order = Bootstrap, App.css (imported by App), the
// portal design system; the runtime theme link is appended to <head> last
// (ThemeProvider), so its .xc-portal token block overrides the defaults.
// #110 (S5): the template stylesheet (every rule commented out) is deleted.
// #189: the shop's layer last; every rule is gated on the html attribute.
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import './portal.css';
import './shopThemeLayer.css';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { BASE_NAME } from './utils/helpers';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={BASE_NAME}>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
